import { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/context/LanguageContext';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setIsVisible(true);
  }, []);

  const handleAccept = () => { localStorage.setItem('cookie_consent', 'accepted'); setIsVisible(false); };
  const handleReject = () => { localStorage.setItem('cookie_consent', 'rejected'); setIsVisible(false); };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6" data-testid="cookie-banner">
      <div className="container-max">
        <div className="bg-[#2D231E] rounded-2xl p-5 md:p-6 shadow-2xl border border-[#FDFBF7]/10 flex flex-col md:flex-row items-start md:items-center gap-4">
          <Cookie className="w-8 h-8 text-[#E28743] flex-shrink-0 hidden md:block" />
          <div className="flex-1">
            <p className="font-sans text-sm text-[#FDFBF7]/90">
              {t('cookie_text')} {t('cookie_more')}{' '}
              <a href="/privacidad" className="text-[#E28743] underline hover:text-[#C44536]">{t('cookie_policy')}</a>.
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0 w-full md:w-auto">
            <Button onClick={handleReject} variant="outline" className="flex-1 md:flex-none rounded-full border-[#FDFBF7]/30 text-[#FDFBF7] hover:bg-[#FDFBF7]/10 text-sm" data-testid="cookie-reject">{t('cookie_reject')}</Button>
            <Button onClick={handleAccept} className="flex-1 md:flex-none btn-primary text-sm" data-testid="cookie-accept">{t('cookie_accept')}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
